var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconStats = function SvgIconStats(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,30H24a3,3,0,0,1-3-3V3a3,3,0,0,1,3-3h3a3,3,0,0,1,3,3V27A3,3,0,0,1,27,30ZM25.5,3A1.5,1.5,0,0,0,24,4.5v21a1.5,1.5,0,1,0,3,0V4.5A1.5,1.5,0,0,0,25.5,3Zm-9,27h-3a3,3,0,0,1-3-3V9a3,3,0,0,1,3-3h3a3,3,0,0,1,3,3V27A3,3,0,0,1,16.5,30ZM15,9a1.5,1.5,0,0,0-1.5,1.5v15a1.5,1.5,0,1,0,3,0v-15A1.5,1.5,0,0,0,15,9ZM6,30H3a3,3,0,0,1-3-3V18a3,3,0,0,1,3-3H6a3,3,0,0,1,3,3v9A3,3,0,0,1,6,30ZM4.5,18A1.5,1.5,0,0,0,3,19.5v6a1.5,1.5,0,1,0,3,0v-6A1.5,1.5,0,0,0,4.5,18Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconStats, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-stats.35b4a8eb.svg";
export { ForwardRef as ReactComponent };